module.exports = __webpack_public_path__ + "static/img/9.2.8b88e2d2.png";